import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from '../actions/external-contact.actions';
import { GenesysCloudExternalContactsState, initialState } from '../genesys-cloud-external-contacts.state';
import { externalContactAdapter } from '../adapters/external-contact.adapter';

const reducer = createReducer(
  initialState(),
  on(Actions.contactLoaded, (state, { contact }) => externalContactAdapter.setOne(contact, state)),
  on(Actions.contactUpdated, (state, { contact }) => externalContactAdapter.upsertOne(contact, state))
);

export function genesysCloudExternalContactsReducer(state: GenesysCloudExternalContactsState, action: Action): GenesysCloudExternalContactsState {
  return reducer(state, action);
}
